import React, { useContext } from 'react'
import View from '../../atoms/View'
import { ItemContext } from 'src/contexts/itemContext'
import { useTranslation } from 'react-i18next'
import { formatPrice } from 'src/helpers/formatPrice'
import Text from 'src/components/atoms/TextNew'
import SuccessTickSvg from 'src/components/other/svg/SuccessTickSvg'

const InRealizationPriceColumn = (): JSX.Element => {
  const itemContext = useContext(ItemContext)
  const { t } = useTranslation()
  if (itemContext === null) {
    throw new Error('itemContext must be used within a ItemProvider')
  }
  return (
    <View className="flex rounded-2 shadow-insetSmall bg-successGreen">
      <View className="w-[168px] flex flex-col items-center justify-center">
        <Text className="text-white text-l font-SemiBold">{t('accepted_offer')}</Text>
        <Text className="text-white text-xl font-Bold">{formatPrice(itemContext.final_price ?? 0)}</Text>
        <Text className="text-white text-l font-SemiBold">Euro</Text>
      </View>
      <View className="w-[104px] flex items-center justify-center rounded-2 bg-successGreen shadow-dropSmall">
        <SuccessTickSvg className="w-13 h-13  text-white" />
      </View>
    </View>
  )
}

export default InRealizationPriceColumn
